{
  "en": {
    "workDescription": {
      "submissionError": "Failed to submit work description request",
      "submissionSuccess": "Work description analysis started. The description will be updated automatically.",
      "completionError": "Work description analysis failed. Please try again.",
      "noDocumentsSelected": "Please select at least one document"
    }
  },
  "fr": {
    "workDescription": {
      "submissionError": "Échec de l'envoi de la requête de description de l'ouvrage",
      "submissionSuccess": "Analyse de la description de l'ouvrage lancée. La description sera mise à jour automatiquement.",
      "completionError": "L'analyse de la description de l'ouvrage a échoué. Veuillez réessayer.",
      "noDocumentsSelected": "Veuillez sélectionner au moins un document"
    }
  },
  "nl": {
    "workDescription": {
      "submissionError": "Fout bij het indienen van het verzoek voor de werkomschrijving",
      "submissionSuccess": "Analyse van de werkomschrijving gestart. De beschrijving wordt automatisch bijgewerkt.",
      "completionError": "Analyse van de werkomschrijving mislukt. Probeer het opnieuw.",
      "noDocumentsSelected": "Selecteer alstublieft minstens één document"
    }
  }
}
